import React, { createContext, useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';

// ID rolí z Catalyst konzole
export const ROLES = {
  KD_SALES: "398000000183129",
  KD_PURCHASE: "398000000420407",    // <-- DOPLŇTE SKUTEČNÉ ID
  KD_ENGINEERING: "398000000342998" // <-- DOPLŇTE SKUTEČNÉ ID
};

// Vytvoření kontextu
const AuthContext = createContext(null);

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [authStatus, setAuthStatus] = useState('loading');

    useEffect(() => {
        const checkAuth = async () => {
            if (window.catalyst && window.catalyst.auth) {
                try {
                    const result = await window.catalyst.auth.isUserAuthenticated();
                    if (result && result.content) {
                        const user = result.content;
                        
                        // --- KLÍČOVÁ ZMĚNA ZDE: Robustnější zjištění role ID ---
                        // Projdeme více možných cest, kde by se roleId mohlo nacházet
                        const userRoleId = user?.role_details?.role_id || user?.zc_zta?.role_details?.role_id || user?.roleId || null;
                        
                        // Najdeme název role podle ID pro snazší práci
                        const roleName = Object.keys(ROLES).find(key => ROLES[key] === userRoleId);

                        // Uložíme všechny potřebné informace do stavu
                        setCurrentUser({ 
                            ...user, 
                            roleId: userRoleId, 
                            roleName: roleName || 'unknown' 
                        });
                        setAuthStatus('authenticated');
                    } else {
                        setAuthStatus('unauthenticated');
                    }
                } catch (error) {
                    console.error("Error during auth check:", error);
                    setAuthStatus('unauthenticated');
                }
            } else {
                console.error("Catalyst auth object not available on window object.");
                toast.error("Authentication service failed to initialize.");
                setAuthStatus('unauthenticated');
            }
        };
        checkAuth();
    }, []);

    if (authStatus === 'loading') {
        return null;
    }

    const value = {
        currentUser,
        isAuthenticated: authStatus === 'authenticated'
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};